import React from 'react';
import './Footer.css';
import { FaXTwitter, FaInstagram, FaEnvelope, FaLocationDot } from 'react-icons/fa6';
import { trackEvent } from '../firebase/analytics';

const Footer = () => {
  const handleSocialClick = (platform) => {
    trackEvent('social_click', { platform, timestamp: new Date().toISOString() });
  };

  return (
    <footer id="contact" className="footer glass">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src="/images/logo.png" alt="Dutchess County Bhabani" className="footer-logo" />
          <p>
            A Bengali cultural community in the Hudson Valley, celebrating heritage,
            festivals, and togetherness.
          </p>
          <div className="social-links">
            <a
              href="https://x.com/dcbhabani"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="X (Twitter)"
              onClick={() => handleSocialClick('x')}
            >
              <FaXTwitter className="social-icon" />
            </a>
            <a
              href="https://instagram.com/dcbhabani"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
              onClick={() => handleSocialClick('instagram')}
            >
              <FaInstagram className="social-icon" />
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Explore</h4>
          <a href="#about">About Us</a>
          <a href="#events">Events</a>
          <a href="#gallery">Gallery</a>
          <a href="#get-involved">Get Involved</a>
        </div>

        <div className="footer-col">
          <h4>Reach Us</h4>
          <a href="mailto:hello@dcbhabani.org" className="footer-contact">
            <FaEnvelope /> hello@dcbhabani.org
          </a>
          <span className="footer-contact">
            <FaLocationDot /> Dutchess County, New York
          </span>
        </div>
      </div>

      <div className="copyright">
        &copy; {new Date().getFullYear()} Dutchess County Bhabani. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
